<script setup lang="ts">
import { useTenantSplashScreen } from '../composables/useTenantSplashScreen'

const { splashScreenUrl } = useTenantSplashScreen()
</script>

<template>
  <div class="flex h-screen flex-col lg:flex-row">
    <div class="flex flex-col lg:w-1/2">
      <div
        class="flex flex-grow flex-col items-center justify-center px-4 py-8 sm:py-12 lg:p-0"
      >
        <div class="w-full max-w-md sm:max-w-lg lg:w-2/3">
          <slot />
        </div>
      </div>
      <div class="mt-auto">
        <slot name="footer" />
      </div>
    </div>

    <div class="bg-gray-50 relative hidden w-full lg:flex lg:w-1/2">
      <div
        class="relative h-full w-full bg-cover bg-center bg-no-repeat"
        :style="{
          backgroundImage: splashScreenUrl ? `url('${splashScreenUrl}')` : '',
        }"
      ></div>
    </div>
  </div>
</template>
